import React from 'react';
import {borderBottomStyle, borderSideStyle} from "./tableStyles";
import {SimulationData} from "../../simulationTypes";

type Props = {
  simulation: SimulationData;
  simulations: SimulationData[];
  setSimulations: React.Dispatch<React.SetStateAction<SimulationData[]>>
}

export const PitchCellName: React.VFC<Props> = (props) => {
  return (
    <td className={borderSideStyle + borderBottomStyle}>
      <input
        type="text"
        className='w-32 text-2xl font-bold bg-transparent text-center'
        value={props.simulation.name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newData = props.simulations.map((simulationData) => {
            if(simulationData.id === props.simulation.id){
              simulationData.name = e.target.value;
              return simulationData;
            } else {
              return simulationData;
            }
          });
          props.setSimulations([...newData]);
        }}
      />
    </td>
  );
};

export const PitchCellTeam: React.VFC<Props> = (props) => {
  return (
    <td className={borderSideStyle + borderBottomStyle}>
      <input
        type="text"
        className='w-32 text-2xl font-bold bg-transparent text-center'
        value={props.simulation.team}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newData = props.simulations.map((simulationData) => {
            if(simulationData.id === props.simulation.id){
              simulationData.team = e.target.value;
              return simulationData;
            } else {
              return simulationData;
            }
          });
          props.setSimulations([...newData]);
        }}
      />
    </td>
  );
};

export const PitchCellNumber: React.VFC<Props> = (props) => {
  return (
    <td className={borderSideStyle + borderBottomStyle}>
      <input
        type="text"
        className='w-16 text-2xl font-bold bg-transparent text-center'
        value={props.simulation.number}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newData = props.simulations.map((simulationData) => {
            if(simulationData.id === props.simulation.id){
              simulationData.number = e.target.value;
              return simulationData;
            } else {
              return simulationData;
            }
          });
          props.setSimulations([...newData]);
        }}
      />
    </td>
  );
};

